import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'gps-tracker-multi-select',
  standalone: false,
  templateUrl: './multi-select.component.html',
  styleUrl: './multi-select.component.scss'
})
export class MultiSelectComponent implements OnInit {

  @Input() isRequired = false;
  @Input() placeholder = 'Select...';
  @Input() classType = '';
  @Input() labelHide = false;
  @Input() labelValue = '';
  @Input() errorMessage = '';
  @Input() disabled = false;
  @Input() id = '';
  @Input() control: AbstractControl | undefined | string;
  @Input() value: any;
  @Input() mainElementStyle: object = {};
  @Input() selectStyle: object = {};
  @Input() inputType: 'primary' | 'primaryWithoutBorder' | 'secondary' | 'secondaryWithoutBorder' | 'warning' | 'warningWithoutBorder' | 'success' | 'successWithoutBorder' | 'error' | 'errorWithoutBorder' = 'primary';
  @Input() labelFieldName: any;
  @Input() data: any = [];
  @Input() enableSearch: boolean = false;
  @Input() searchPlaceholder: string = 'Search...';

  @Output() change: EventEmitter<any> = new EventEmitter();

  searchText: string = '';
  filteredDataList: any[] = [];

  ngOnInit() {
    this.filteredDataList = this.data;
  }

  ngOnChanges() {
    if (this.data) {
      this.filteredDataList = this.data;
      this.searchText = '';
    }
  }

  onSearchChange() {
    if (!this.searchText || this.searchText.trim() === '') {
      this.filteredDataList = this.data;
      return;
    }

    const search = this.searchText.toLowerCase();
    this.filteredDataList = this.data.filter((item: any) => {
      const fieldValue = item[this.labelFieldName];
      return fieldValue && fieldValue.toLowerCase().includes(search);
    });
  }

  onValueChange($event: any) {
    this.change.emit($event);
  }

  stopPropagation(event: Event) {
    event.stopPropagation();
  }
}
